<nav class="navigation">
  <ng-container *ngFor="let item of items">
    <ng-container *ngxPermissionsOnly="item.permissions || []">
      <a
        class="navigation-item"
        [routerLink]="item.link"
        [queryParams]="item.queryParams"
        routerLinkActive="navigation-item_active"
        (click)="item.action && item.action()"
      >
        <div *ngIf="item.icon" class="navigation-item__icon">
          <app-icon class="icon" [size]="'18px'" [src]="item.icon"></app-icon>

          <tui-badge *ngIf="item.badgeCount | async as badgeCount" class="badge" [size]="'s'">
            {{ badgeCount }}
          </tui-badge>
        </div>

        <div>
          <div class="navigation-item__title">
            {{ item.title | translate }}
          </div>
        </div>
      </a>
    </ng-container>
  </ng-container>
</nav>
